import '@fontsource/geist/400.css';
import '@fontsource/geist/500.css';
import '@fontsource/geist/600.css';
import './index.css';

import { buildThemeCss } from '@antoja/shared';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import { createConnection } from './lib/supabase';

const themeStyle = document.createElement('style');
themeStyle.id = 'antoja-theme';
themeStyle.textContent = buildThemeCss();
document.head.prepend(themeStyle);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App connection={createConnection(import.meta.env)} />
  </StrictMode>,
);
